"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".info-card[_ngcontent-%COMP%]{min-width:120px;font-family:Quicksand,\"Helvetica Neue\",sans-serif;margin:20px auto;color:#000;font-size:20px}\n/*# sourceMappingURL=information-sheet.component.css.map*/"];
exports.styles = styles;
